import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import nl from "./locales/nl.json";
import ja from "./locales/ja.json";
import zh from "./locales/zh.json";
import ar from "./locales/ar.json";
import ru from "./locales/ru.json";
import ko from "./locales/ko.json";

export const LANGUAGES = [
  { code: "fr", label: "Français",  flag: "🇫🇷", dir: "ltr" },
  { code: "en", label: "English",   flag: "🇬🇧", dir: "ltr" },
  { code: "es", label: "Español",   flag: "🇪🇸", dir: "ltr" },
  { code: "de", label: "Deutsch",   flag: "🇩🇪", dir: "ltr" },
  { code: "it", label: "Italiano",  flag: "🇮🇹", dir: "ltr" },
  { code: "pt", label: "Português", flag: "🇵🇹", dir: "ltr" },
  { code: "nl", label: "Nederlands",flag: "🇳🇱", dir: "ltr" },
  { code: "ja", label: "日本語",     flag: "🇯🇵", dir: "ltr" },
  { code: "zh", label: "中文",       flag: "🇨🇳", dir: "ltr" },
  { code: "ar", label: "العربية",   flag: "🇸🇦", dir: "rtl" },
  { code: "ru", label: "Русский",   flag: "🇷🇺", dir: "ltr" },
  { code: "ko", label: "한국어",     flag: "🇰🇷", dir: "ltr" },
];

export const RTL_LANGS = LANGUAGES.filter((l) => l.dir === "rtl").map((l) => l.code);

// Map i18n code -> OpenAI TTS voice (fable = warm-magical FR default; nova = softer for wide range)
// The OpenAI tts-1 model detects language from the input text itself, but we pass the voice hint here.
export const TTS_VOICE_BY_LANG = {
  fr: "fable",  en: "fable",  es: "nova",   de: "nova",   it: "nova",
  pt: "nova",   nl: "nova",   ja: "shimmer",zh: "shimmer",ar: "onyx",
  ru: "onyx",   ko: "shimmer",
};

// Human name of the language, used inside AI image prompts (for legends, cultural feel).
export const LANG_NAME_FOR_AI = {
  fr: "français", en: "English", es: "español", de: "Deutsch", it: "italiano",
  pt: "português", nl: "Nederlands", ja: "日本語", zh: "简体中文",
  ar: "العربية", ru: "Русский", ko: "한국어",
};

const applyDir = (lng) => {
  const code = (lng || "").slice(0, 2);
  const meta = LANGUAGES.find((l) => l.code === code);
  const dir = meta?.dir === "rtl" ? "rtl" : "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", code || "fr");
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
      it: { translation: it },
      pt: { translation: pt },
      nl: { translation: nl },
      ja: { translation: ja },
      zh: { translation: zh },
      ar: { translation: ar },
      ru: { translation: ru },
      ko: { translation: ko },
    },
    fallbackLng: "fr",
    supportedLngs: LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "chronos.lang",
      caches: ["localStorage"],
    },
  });

applyDir(i18n.language);
i18n.on("languageChanged", applyDir);

export default i18n;
